import React, { useEffect, useRef } from "react";
import gsap from "gsap";

import LeftImg from "../../assets/group1.png"; // Big Deal Of The Day
import RightImg from "../../assets/group2.png"; // Best Collection
import { useNavigate } from "react-router-dom";

function Salespromo4() {
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    // Entry Animation
    gsap.fromTo(
      [leftRef.current, rightRef.current],
      { opacity: 0, y: 60, scale: 0.95 },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 1.2,
        stagger: 0.2,
        ease: "power3.out",
      },
    );

    // Hover Animation
    const cards = [leftRef.current, rightRef.current];

    cards.forEach((card) => {
      if (!card) return;

      const hoverEnter = () => {
        gsap.to(card, {
          y: -12,
          scale: 1.03,
          duration: 0.5,
          ease: "power2.out",
        });
      };

      const hoverLeave = () => {
        gsap.to(card, {
          y: 0,
          scale: 1,
          duration: 0.5,
          ease: "power2.out",
        });
      };

      card.addEventListener("mouseenter", hoverEnter);
      card.addEventListener("mouseleave", hoverLeave);

      return () => {
        card.removeEventListener("mouseenter", hoverEnter);
        card.removeEventListener("mouseleave", hoverLeave);
      };
    });
  }, []);

  return (
    <section className="salespromo4 py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* LEFT CARD - Big Deal Of The Day */}
          <div
            ref={leftRef}
            className="group flex-1 bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 flex flex-col lg:flex-row border border-gray-100"
          >
            {/* Text Content */}
            <div className="flex-1 p-10 lg:pr-8 flex flex-col justify-center">
              <p className="text-[#D4AF37] font-medium tracking-widest text-sm mb-3">
                Men Collection!
              </p>

              <h2 className="text-4xl md:text-4xl font-bold leading-none text-black mb-6 product-tabs">
                Big Deal Of
                <br />
                The Day
              </h2>

              <p className="text-gray-600 text-lg mb-8 ">
                We’ve been waiting for you!
              </p>

              <a
                onClick={() => navigate("/fragrance?tags=Men")}
                className="cursor-pointer inline-block px-8 py-3.5 border-2 border-black text-black font-medium rounded-full hover:bg-black hover:text-white transition-all duration-300 w-fit"
              >
                SHOP NOW
              </a>
            </div>

            {/* Image Side - No Background Color */}
            <div className="flex-1 flex items-center justify-center p-8 lg:p-12 relative overflow-hidden min-h-[320px]">
              <img
                src={LeftImg}
                alt="Big Deal Perfumes"
                className="max-h-[260px] w-auto object-contain group-hover:scale-110 transition-transform duration-700 drop-shadow-md"
              />
            </div>
          </div>

          {/* RIGHT CARD - Best Collection */}
          <div
            ref={rightRef}
            className="group flex-1 bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 flex flex-col lg:flex-row border border-gray-100"
          >
            {/* Text Content */}
            <div className="flex-1 p-10 lg:pr-8 flex flex-col justify-center">
              <p className="text-[#D4AF37] font-medium tracking-widest text-sm mb-3">
                Choose Your Favorite Perfume
              </p>

              <h2 className="text-4xl md:text-4xl font-bold leading-none text-black mb-6 product-tabs   ">
                Best
                <br />
                Collection
              </h2>

              <p className="text-gray-600 text-lg mb-8">
                We’ve been waiting for you!
              </p>

              <a
                onClick={() => navigate("/fragrance?tags=Best+Sales")}
                className="cursor-pointer inline-block px-8 py-3.5 border-2 border-black text-black font-medium rounded-full hover:bg-black hover:text-white transition-all duration-300 w-fit"
              >
                SHOP NOW
              </a>
            </div>

            {/* Image Side - No Background Color */}
            <div className="flex-1 flex items-center justify-center p-8 lg:p-12 relative overflow-hidden min-h-[320px]">
              <img
                src={RightImg}
                alt="Best Collection Perfumes"
                className="max-h-[260px] w-auto object-contain group-hover:scale-110 transition-transform duration-700 drop-shadow-md"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Salespromo4;
